exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-delete-button[data-v-0b5e6575] {\n  margin-left: 10px;\n}\n.gallery-form-item[data-v-0b5e6575] {\n  margin-bottom: 24px;\n}\n.selected-picture-holder img.selected-thumbnail[data-v-0b5e6575] {\n  display: block;\n  max-width: 300px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n.teka-container[data-v-0b5e6575] {\n  padding-bottom: 30px;\n}\n.teka-container iframe[data-v-0b5e6575] {\n    width: 100%;\n    height: calc(100vh - 200px);\n    border: 0;\n}\n", ""]);

// exports
